export default {
  sku: {
    order: 1,
    label: 'SKU',
    dataKey: 'sku.sku',
    isText: true
  },
  item: {
    order: 2,
    label: 'Item',
    dataKey: 'item.name',
    isText: true
  },
  type: {
    order: 3,
    label: 'Type',
    dataKey: 'item.itemType',
    isText: true
  }
};
